<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="商品名称">
              <a-input v-model="queryParam.name" allow-clear placeholder="请输入商品名称" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="条形码">
              <a-input v-model="queryParam.barcode" allow-clear placeholder="请输入商品条形码" />
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <a-button type="primary" icon="search" @click="$refs.table.refresh(true)">查找</a-button>
          </a-col>
          <a-col :md="2" :sm="24">
            <a-button type="primary" icon="plus" @click="handleCreate">添加</a-button>
          </a-col>
          <a-col :md="2" :sm="24">
            <a-button type="primary" icon="import" @click="handleImport">批量导入</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询结果 -->
    <s-table
      ref="table"
      :loading="loading"
      :columns="columns"
      :pageNum="pageNum"
      :data="loadData"
      size="small"
      :scroll="{ x: 1000 }"
      rowKey="id">

      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="img" slot-scope="img">
        <a-avatar
          slot="img"
          :src="img"
          shape="square"
          @click="openPreview(img)"
        />
      </span>
      <div slot="count" slot-scope="text" style="min-width: 100px; max-width: 120px; text-align: right; padding-right: 10px;">
        {{ text | numberFormat }}
      </div>
      <div slot="price_render" slot-scope="text" style="min-width: 100px; max-width: 150px; text-align: right">
        {{ (text / 100).toFixed(2) | numberFormat }}
      </div>
      <div slot="show_on_index" slot-scope="text, record">
        <a-switch @change="showConfirm(record.id, text, 'show_on_index')" :checked="text"/>
      </div>
      <div slot="is_sale" slot-scope="text, record">
        <a-switch @change="showConfirm(record.id, text, 'is_sale')" :checked="text"/>
      </div>
      <div slot="is_new" slot-scope="text, record">
        <a-switch @change="showConfirm(record.id, text, 'is_new')" :checked="text"/>
      </div>
      <div slot="is_hot" slot-scope="text, record">
        <a-switch @change="showConfirm(record.id, text, 'is_hot')" :checked="text"/>
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleChangeCount(record)">修改库存</a>
          <!--            <a-divider type="vertical" />-->
          <!--            <a @click="handleVipPrice(record)">会员价</a>-->
          <a-divider type="vertical" />
          <a @click="handleUpdate(record)">编辑</a>
          <a-divider type="vertical" />
<!--          <a-popconfirm-->
<!--            title="确定要删除么？"-->
<!--            ok-text="确定"-->
<!--            cancel-text="取消"-->
<!--            @confirm="handleDelete(record)"-->
<!--          >-->
<!--            <a>删除</a>-->
<!--          </a-popconfirm>-->
          <a @click="handleCountRecord(record)">数量变动记录</a>
        </template>
      </span>
    </s-table>

    <a-modal v-model="previewvisible" title="预览" width="350px" :footer="null">
      <img alt="example" style="width: 300px; margin: 0 auto" :src="previewurl" />
    </a-modal>
    <create-goods-import-form
      ref="goodsImportModal"
      v-if="import_form_visible"
      :visible.sync="import_form_visible"
      :loading="importConfirmLoading"
      @cancel="handleImportCancel"
      @ok="handleImportOk" />
    <change-count-form
      ref="goodsChangeCountModal"
      v-if="visible_change"
      :visible.sync="visible_change"
      :loading="countConfirmLoading"
      :model="goodsDetail"
      @cancel="handleChangeCountCancel"
      @ok="handleChangeCountOk" />
  </a-card>
</template>

<script>
import { listGoods, deleteGoods, editGoods, goodsDataImport } from '@/api/applet_goods'
import { STable } from '@/components'
import CreateGoodsImportForm from './CreateGoodsImportForm'
import ChangeCountForm from './ChangeCountForm'

const { MessageBox } = require('element-ui')
export default {
  name: 'GoodsList',
  components: {
    STable,
    CreateGoodsImportForm,
    ChangeCountForm
  },
  data () {
    return {
      pageNum: 1,
      list: [],
      total: 0,
      loading: false,
      import_form_visible: false,
      importConfirmLoading: false,
      countConfirmLoading: false,
      units: this.$Dictionaries.unit,
      goods_type: this.$Dictionaries.goods_type,
      previewurl: '',
      previewvisible: false,
      listLoading: true,
      visible_change: false,
      queryParam: {},
      goodsDetail: undefined,
      downloadLoading: false,
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '图片',
          dataIndex: 'picture',
          width: '100px',
          scopedSlots: { customRender: 'img' }
        },
        {
          title: '微信展示名称',
          dataIndex: 'brief',
          width: '150px',
          ellipsis: true
        },
        {
          title: '条形码',
          dataIndex: 'barcode',
          width: '150px',
          ellipsis: true
        },
        {
          title: '品牌',
          dataIndex: 'brand',
          width: '150px',
          ellipsis: true
        },
        {
          title: '库存',
          dataIndex: 'count',
          align: 'right',
          width: 120,
          scopedSlots: { customRender: 'count' }
        },
        {
          title: '销售量',
          dataIndex: 'sale_count',
          align: 'right',
          width: 120,
          scopedSlots: { customRender: 'count' }
        },
        {
          title: '单位',
          dataIndex: 'unit',
          align: 'center',
          width: 100,
          customRender: (text) => this.units[text] ? this.units[text] : '-'
        },
        {
          title: '成本价',
          dataIndex: 'cost_price',
          align: 'right',
          width: '150px',
          scopedSlots: { customRender: 'price_render' }
        },
        {
          title: '建议售价',
          dataIndex: 'suggested_price',
          align: 'right',
          width: '150px',
          scopedSlots: { customRender: 'price_render' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: '280px',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return listGoods(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data)
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      }
    }
  },
  created () {
    this.setCurrentPage()
  },
  methods: {
    setCurrentPage () {
      // const page = sessionStorage.getItem('CurrentPage')
      const page = this.$store.getters.pop
      if (page) {
        console.log(page)
        const current = page.split('#$$#')[0]
        const query = page.split('#$$#')[1]
        const path = page.split('#$$#')[2]
        sessionStorage.removeItem('CurrentPage')
        if (path === this.$route.path) {
          if (!isNaN(Number(current))) {
            this.pageNum = Number(current)
          }
          if (query) {
            this.queryParam = JSON.parse(query)
          }
        } else {
          this.queryParam = {}
          this.$store.dispatch('clear')
        }
      }
    },
    upDownTitle (record) {
      return '确定要' + (record.is_sale ? '下架' : '上架') + '吗？'
    },
    handleCreate () {
      this.$router.push({ path: '/fs/shop_goods/create' })
    },
    onChangeSwitch (id, checked) {
      console.log(id, checked)
    },
    showConfirm (id, checked, tag) {
      console.log(id, checked)
      const goods = {}
      goods[tag] = !checked
      this.editGoods(goods, id)
    },
    editGoods (goods, id) {
      this.loading = true
      editGoods(goods, id)
        .then(response => {
          if (response.code === 1000) {
            this.$refs.table.refresh()
          }
        })
        .catch(response => {
          console.log(response)
        }).finally(() => {
          this.loading = false
      })
    },
    handleUpdate (row) {
      // sessionStorage.setItem('CurrentPage', this.$refs.table.getCurrent() + '#$$#' + JSON.stringify(this.queryParam) + '#$$#' + this.$route.path)
      this.$store.dispatch('push', this.$refs.table.getCurrent() + '#$$#' + JSON.stringify(this.queryParam) + '#$$#' + this.$route.path)
      this.$router.push({ path: '/fs/shop_goods/edit', query: { id: row.id } })
    },
    handleCountRecord (row) {
      console.log(row)
      sessionStorage.setItem('CurrentPage', this.$refs.table.getCurrent() + '#$$#' + JSON.stringify(this.queryParam) + '#$$#' + this.$route.path)
      this.$router.push({ path: '/fs/shop_goods/count_record', query: { goods_id: row.id, barcode: row.barcode, goods_name: row.name, brief: row.brief } })
    },
    handleChangeCount (row) {
      this.visible_change = true
      this.goodsDetail = row
    },
    handleVipPrice (row) {
      sessionStorage.setItem('CurrentPage', this.$refs.table.getCurrent() + '#$$#' + JSON.stringify(this.queryParam) + '#$$#' + this.$route.path)
      this.$router.push({ path: '/fs/shop_goods/vip_price', query: { id: row.id, barcode: row.barcode, name: row.name } })
    },
    handleGallery (row) {
      sessionStorage.setItem('CurrentPage', this.$refs.table.getCurrent() + '#$$#' + JSON.stringify(this.queryParam) + '#$$#' + this.$route.path)
      this.$router.push({ path: '/applet_goods/gallery', query: { id: row.id } })
    },
    handleSale (row) {
      console.log(row)
      editGoods({ is_sale: !row.is_sale }, row.id)
        .then(response => {
          this.$refs.table.refresh()
        })
        .catch(response => {
          MessageBox.alert('错误：' + response, '警告', {
            confirmButtonText: '确定',
            type: 'error'
          })
        })
    },
    openPreview (url) {
      if (url === undefined || url === '') {
        return
      }
      this.previewvisible = true
      this.previewurl = url
    },
    handleDelete (row) {
      deleteGoods(row.id).then(response => {
        this.$refs.table.refresh()
      }).catch(response => {
        console.log(response)
      })
    },
    handleImport () {
      this.import_form_visible = true
    },
    handleImportCancel () {
      this.import_form_visible = false
      const form = this.$refs.goodsImportModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleChangeCountCancel () {
      this.visible_change = false
      const form = this.$refs.goodsChangeCountModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleImportOk (fileList) {
      const form = this.$refs.goodsImportModal.form
      this.importConfirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          // 新增
          const formData = new FormData()
          formData.append('file', fileList[0])
          formData.append('supplier_id', this.$Dictionaries.corporation_id)
          goodsDataImport(formData).then(res => {
            console.log(res)
            // 刷新表格
            this.$refs.table.refresh()
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.import_form_visible = false
            this.importConfirmLoading = false
            form.resetFields()
          })
        } else {
          this.importConfirmLoading = false
        }
      })
    },
    handleChangeCountOk () {
      const form = this.$refs.goodsChangeCountModal.form
      this.countConfirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          // 新增
          editGoods(values, this.goodsDetail.id).then(res => {
            console.log(res)
            // 刷新表格
            this.$refs.table.refresh()
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.visible_change = false
            this.countConfirmLoading = false
            form.resetFields()
          })
        } else {
          this.countConfirmLoading = false
        }
      })
    }
  }
}
</script>
<style scoped>
.ant-card-body {
  padding: 12px;
  zoom: 1;
}
.table-expand {
  font-size: 0;
  padding-left: 60px;
}

.table-expand label {
  width: 100px;
  color: #99a9bf;
}

.table-expand .a-form-item {
  margin-right: 0;
  margin-bottom: 0;
}

.gallery {
  width: 80px;
  margin-right: 10px;
}

.goods-detail-box img {
  width: 100%;
}

</style>
